import { Component, ViewChild, OnInit, AfterViewInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { PlotlyService, PlotlyComponent } from 'angular-plotly.js';
import { ScrubberDataService } from 'src/app/services/scrubber-data.service';
import { Observable } from 'rxjs';
import { StatuteCategoryMapping, CrimSubCategory } from '../../models/batch-row';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-statute-breakdown-plot',
  templateUrl: './statute-breakdown-plot.component.html',
  styleUrls: ['./statute-breakdown-plot.component.less']
})
export class StatuteBreakdownPlotComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('cmp') input : PlotlyComponent;
  _selectedStat : number;
  _selectedCat : CrimSubCategory;
  offset : number = 0;
  fetch : number = 50;
  @Output() fetchDataEvent : EventEmitter<number> = new EventEmitter();
  @Input() stateToRun : string;
  public graph = {
    data: [],
  layout: {autosize: true, title: 'Statute Breakdown by state'}
  };
  _currentStatMappings : StatuteCategoryMapping[] = [];
  constructor(public scrubs: ScrubberDataService, public plotly: PlotlyService, public toast : ToastrService){}
  ngOnDestroy(): void {
    this.scrubs.$plotRecordsLoaded.unsubscribe();
  }
  ngAfterViewInit(): void {
  }
  ngOnInit(): void { 
    this.scrubs.$plotRecordsLoaded.subscribe(ev=>{
      this.update();
    })

   }

  logg(e : any){
    console.log(e);
    this._selectedStat = e.points[0].text;
    this.fetchDataEvent.emit(e.points[0].text);
    this.scrubs.loadStatuteCategoryMappings(e.points[0].text).pipe().subscribe(
      (scs: any) => {
        this._currentStatMappings = scs.map(e => Object.assign(new StatuteCategoryMapping, e));
        console.log('current mappings',this._currentStatMappings);
      },
      (err: any) => {
        this.toast.error('Statute Category Mappings Failed to Load');
      },
    );
  }

  page(forward : boolean){
    if(forward){
      this.offset +=50;
    }
    else{
      this.offset -=50;
      if(this.offset < 0) this.offset = 0;
    }

    this.scrubs.loadStatuteBreakout(this.stateToRun,this.offset,this.fetch);
  }

  addCategoryForStatute(cat : CrimSubCategory){
    console.log('adding category for statute', cat);
    let catToAdd = this.scrubs._categories.find(ct=>{ return ct.id == this._selectedCat.id;});
    this.scrubs.setStatuteCategoryMappings(this._selectedStat,catToAdd.id).pipe().subscribe(
      (scs: any) => {
        this._currentStatMappings = scs.map(e => Object.assign(new StatuteCategoryMapping, e));
        // console.log(this._currentStatMappings);
      },
      (err: any) => {
        this.toast.error('Statute Category Mapping Failed to Save');
      },
    );
    // console.log('current selected category', catToAdd);

  }

  update(){
    let dta = [];
    // this.scrubs._plotData.forEach(dt =>{
    //   dta.push({
    //     x: dt.indexx,
    //     y: dt.mappedOffensesCount,
    //     text : dt.statuteId,
    //     type: 'bar',
    //     marker: {
    //       color: dt.hasMappings ? 'blue' : 'red',
    //     }
    //   })
    // })

    let dtas = {
      x: this.scrubs._plotData.filter(pd => {return pd.hasMappings;}).map(ec =>{ return ec.indexx; }),
      y:this.scrubs._plotData.filter(pd => {return pd.hasMappings;}).map(ec =>{ return ec.mappedOffensesCount; }),
      text : this.scrubs._plotData.filter(pd => {return pd.hasMappings;}).map(ex =>{return ex.statuteId;}),
      type: 'bar',
      marker: {
        color: 'blue',
      }
    };

    let dtas2 = {
      x: this.scrubs._plotData.filter(pd => {return !pd.hasMappings;}).map(ec =>{ return ec.indexx; }),
      y:this.scrubs._plotData.filter(pd => {return !pd.hasMappings;}).map(ec =>{ return ec.mappedOffensesCount; }),
      text : this.scrubs._plotData.filter(pd => {return !pd.hasMappings;}).map(ex =>{return ex.statuteId;}),
      type: 'bar',
      marker: {
        color: 'red',
      }
    };
    this.plotly.update(this.input.plotlyInstance,[dtas,dtas2],this.graph.layout);
  }
}
